import { useContext } from "react";
import { db } from "../../../firebase/config";
import { useFirestore } from "../../../firebase/useFirestore";
import { SavedIcon } from "../../../StateManagment/SavedIcon";
import ReadOnlyGuard from "../../common/ReadOnlyGuard";

const PrivacyPolicy = () => {
    const [saved, setSaved] = useContext(SavedIcon);

    const compagny = useFirestore("CompagnyMeta");

    const updateField = (fieldName) => (e) => {
        const value = e.target.value;
        const docid = e.target.dataset.docid;

        db.collection("CompagnyMeta")
            .doc(docid)
            .update({
                [fieldName]: value,
            })
            .then(() => {
                setSaved("flex");
            });
    };

    return (
        <div className="dashboard-container">
            <h2>Privacybeleid</h2>
            <p>
                Deze tekst verschijnt bij de akkoord-checkbox op intake-formulieren.
            </p>
            {compagny && compagny.map((comp) => (
                <ReadOnlyGuard key={comp.ID} edit="addresses.edit">
                <div className="privacy-policy-fields">
                    <div className="privacy-policy-row">
                        <div className="privacy-policy-field">
                            <label>Tekst vóór link</label>
                            <input
                                className="input-classic"
                                type="text"
                                data-docid={comp.docid}
                                defaultValue={comp.PrivacyTextBefore || ""}
                                onChange={updateField("PrivacyTextBefore")}
                                placeholder="Ik ga akkoord met het"
                            />
                        </div>
                        <div className="privacy-policy-field">
                            <label>Linktekst</label>
                            <input
                                className="input-classic"
                                type="text"
                                data-docid={comp.docid}
                                defaultValue={comp.PrivacyLinkLabel || ""}
                                onChange={updateField("PrivacyLinkLabel")}
                                placeholder="privacybeleid"
                            />
                        </div>
                    </div>
                    <div className="privacy-policy-row">
                        <div className="privacy-policy-field">
                            <label>URL</label>
                            <input
                                className="input-classic"
                                type="text"
                                data-docid={comp.docid}
                                defaultValue={comp.PrivacyLinkUrl || ""}
                                onChange={updateField("PrivacyLinkUrl")}
                                placeholder="https://voorbeeld.nl/privacy"
                            />
                        </div>
                        <div className="privacy-policy-field">
                            <label>Tekst na link (optioneel)</label>
                            <input
                                className="input-classic"
                                type="text"
                                data-docid={comp.docid}
                                defaultValue={comp.PrivacyTextAfter || ""}
                                onChange={updateField("PrivacyTextAfter")}
                                placeholder="."
                            />
                        </div>
                    </div>
                </div>
                </ReadOnlyGuard>
            ))}
        </div>
    );
};

export default PrivacyPolicy;
